import React, { useState } from "react";
import AifPdfDownloadBlock from "./AifPdfDownloadBlock";
import { EReportsURLKeys } from "@adapters/infrastructures/urlConfig/Reports/reportsUrl";
import downloadDI from "@frameworks/web/components/Reports/RebrandedReports/DownloadReports/di/serviceLocator";
import { useSelector } from "react-redux";
import SuccessPopup from "./SMCaseLoadPopup/SmcasePopupSuccess";
import SmallcasePopup from "./SMCaseLoadPopup/SmcasePopupLoader";
import PopupFail from "./SMCaseLoadPopup/SmcasePopupFail";
import DeviceContext from "@frameworks/web/components/generic/customHooks/indentifyDevice";
import SmcasePopupFailMob from "./SMCaseLoadPopup/SmcasePopupFailMob";
import SmcasePopupSuccessMob from "./SMCaseLoadPopup/SmcasePopupSuccessMob";
import SmcasePopupLoaderMob from "./SMCaseLoadPopup/SmcasePopupLoaderMob";
import Drawer from "react-bottom-drawer";
import PANPassword from "../RebrandedReports/GenericComponents/PANPassword";
const AifPdfDownload = (props) => {
    const device = DeviceContext();
    const [downloadAif, setDownloadAif] = useState(props === null || props === void 0 ? void 0 : props.downloadAif);
    const [downloadLoader, setDownloadLoder] = React.useState(false);
    const [downloadSuccess, setDownloadSuccess] = React.useState(false);
    const [downloadFail, setDownloadFail] = React.useState(false);
    const { selectedMember } = useSelector((state) => state.FamilyTagging.familyDetails.reducersData);
    const downloadAifPdf = () => {
        let searchParams = [
            {
                key: "folioNumber",
                value: props.selectedData.folioNumber,
            },
            {
                key: "accountCode",
                value: selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode,
            },
        ];
        let downloadPayload = {
            searchParams,
            method: "GET",
            urlParts: {
                firstPart: EReportsURLKeys.COMMON_URL,
                secondPart: "/aif/statement",
            },
        };
        setDownloadLoder(true);
        setDownloadAif(false);
        downloadDI.downloadReport
            .downloadAndSendReport(null, downloadPayload)
            .then(() => {
            setDownloadLoder(false);
            setDownloadSuccess(true);
        })
            .catch((error) => {
            setDownloadLoder(false);
            setDownloadFail(true);
        });
    };
    const FailureMessage = () => {
        return "to download";
    };
    const loaderMessage = () => {
        return (React.createElement("div", { className: "popup-message-container d-flex flex-column justify-content-center align-items-center gap-10 message-block" },
            React.createElement("span", { className: "detailed-status-message" }, "Your request is being processed"),
            React.createElement(PANPassword, { reportText: "Statement" })));
    };
    const downloadSuccessNode = () => {
        return (React.createElement("div", { className: "popup-message-container d-flex flex-column justify-content-center align-items-center gap-10 message-block" },
            React.createElement("span", { className: "status-message" },
                "Your request was successfully processed.",
                " "),
            React.createElement(PANPassword, { reportText: "Statement" })));
    };
    const closeDrawerDownloadS = React.useCallback(() => {
        props.setDownloadAif(false), setDownloadSuccess(false);
    }, []);
    return (React.createElement(React.Fragment, null, device && (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement(React.Fragment, null,
        downloadAif && (React.createElement("div", { className: "modalBackground" },
            React.createElement("div", { className: "modalContainer smallcase-popup holding-report-loader aif-pdf-block" },
                React.createElement(AifPdfDownloadBlock, { headTitle: "Download AIF statement", onClick: downloadAifPdf, closePopup: closeDrawerDownloadS })))),
        downloadLoader && (React.createElement("div", { className: "modalBackground" },
            React.createElement("div", { className: "modalContainer smallcase-popup holding-report-loader aif-pdf-loader" },
                React.createElement(SmallcasePopup, { Title: "Download AIF statement", messageReactNode: loaderMessage(), parentClass: "aif-loader", reportText: true, aifPdfText: "Statement", disablePnPassword: true })))),
        downloadSuccess && (React.createElement("div", { className: "modalBackground" },
            React.createElement("div", { className: "modalContainer smallcase-popup holding-report-success aif-pdf-success" },
                React.createElement(SuccessPopup, { setDownloadSuccess: setDownloadSuccess, Title: "Download AIF statement", sendBack: true, pageName: "Holding", goBack: () => {
                        props.setDownloadAif(false);
                    }, messageReactNode: downloadSuccessNode(), operation: "download", reportText: true, aifPdfText: "Statement", disablePnPassword: true })))),
        downloadFail && (React.createElement("div", { className: "modalBackground" },
            React.createElement("div", { className: "modalContainer smallcase-popup holding-report-loader aif-pdf-failure" },
                React.createElement(PopupFail, { setDownloadFail: setDownloadFail, Title: "Download AIF statement", goBack: () => props.setDownloadAif(false), operation: "download", pageName: "Holding", reportText: true, message: `<span class='DMSans_16_500'>We ran into some technical  difficulties,<br> please try ${FailureMessage()} the report again!</span>`, sendBack: true })))))) : (React.createElement(React.Fragment, null,
        React.createElement(Drawer, { duration: 250, hideScrollbars: true, onClose: () => props.setDownloadAif(false), isVisible: downloadAif, className: "drawer__handle-wrapper backgroundcolor_bluedrawer" },
            React.createElement("div", { className: "smallcase-popup holding-report-loader aif-pdf-block-mob" },
                React.createElement(AifPdfDownloadBlock, { headTitle: "Download AIF statement", onClick: downloadAifPdf, closePopup: () => {
                        props.setDownloadAif(false);
                    } }))),
        React.createElement(Drawer, { duration: 250, hideScrollbars: true, onClose: () => {
                setDownloadSuccess(false), setDownloadFail(false);
            }, isVisible: downloadLoader || downloadSuccess || downloadFail, className: "drawer__handle-wrapper" },
            downloadLoader && (React.createElement("div", { className: "smallcase-popup holding-report-loader aif-pdf-loader-mob" },
                React.createElement(SmcasePopupLoaderMob, { Title: "Download AIF statement", messageReactNode: loaderMessage(), parentClass: "aif-loader", reportText: true, aifPdfText: "Statement", disablePnPassword: true }))),
            downloadSuccess && (React.createElement("div", { className: "smallcase-popup holding-report-success aif-pdf-success-mob" },
                React.createElement(SmcasePopupSuccessMob, { Title: "Download AIF statement", sendBack: true, pageName: "Holding", messageReactNode: downloadSuccessNode(), operation: "download", reportText: true, closeDrawer: closeDrawerDownloadS, aifPdfText: "Statement", disablePnPassword: true }))),
            downloadFail && (React.createElement("div", { className: "smallcase-popup holding-report-loader aif-pdf-failure-mob" },
                React.createElement(SmcasePopupFailMob, { goBack: () => {
                        setDownloadFail(false);
                    }, operation: "download", pageName: "Holding", sendBack: true, message: `<span class='DMSans_16_500'>We ran into some technical  difficulties,<br> please try ${FailureMessage()} the report again!</span>` }))))))));
};
export default AifPdfDownload;
